import React, { useState } from 'react';
import { VendorLogin } from './components/auth/VendorLogin';
import { VendorPortal } from './components/vendor/VendorPortal';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentVendor, setCurrentVendor] = useState(null);
  const handleLogin = vendor => {
    setIsAuthenticated(true);
    setCurrentVendor(vendor);
  };
  const handleLogout = () => {
    setIsAuthenticated(false);
    setCurrentVendor(null);
  };
  if (!isAuthenticated) {
    return <VendorLogin onLogin={handleLogin} data-id="element-0" />;
  }
  return <VendorPortal vendor={currentVendor} onLogout={handleLogout} data-id="element-1" />;
}